var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGuidesVideos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 192 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_138_2267)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16.1271,
    width: 110.123,
    height: 76.5432,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.7161,
    y: 54.6453,
    width: 24.1975,
    height: 1.97531,
    transform: "rotate(90 38.7161 54.6453)",
    fill: "#D8C8FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.7285,
    cy: 54.6454,
    r: 5.92593,
    transform: "rotate(90 37.7285 54.6454)",
    fill: "#D8C8FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.7285,
    cy: 75.386,
    r: 5.92593,
    transform: "rotate(90 37.7285 75.386)",
    fill: "#D8C8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.7161,
    y: 33.4109,
    width: 24.1975,
    height: 1.97531,
    transform: "rotate(90 38.7161 33.4109)",
    fill: "#D8C8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.5556,
    y: 29.9539,
    width: 59.2593,
    height: 6.41975,
    rx: 3.20988,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.5556,
    y: 51.1882,
    width: 59.2593,
    height: 6.41975,
    rx: 3.20988,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.5556,
    y: 71.9297,
    width: 59.2593,
    height: 6.41975,
    rx: 3.20988,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.7285,
    cy: 33.9048,
    r: 5.92593,
    transform: "rotate(90 37.7285 33.9048)",
    fill: "#9061FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_138_2267)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.8765,
    y: 45.757,
    width: 110.123,
    height: 76.5432,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.64 82.4841L114.389 73.4209C113.059 72.7607 111.499 73.7278 111.499 75.2122L111.499 93.3386C111.499 94.8229 113.059 95.79 114.389 95.1298L132.64 86.0667C134.12 85.3314 134.12 83.2193 132.64 82.4841Z",
    fill: "#9061FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_138_2267",
    x: 0,
    y: 0.127075,
    width: 142.123,
    height: 108.543,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_138_2267"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_138_2267",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_138_2267",
    x: 49.8765,
    y: 29.757,
    width: 142.123,
    height: 108.543,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_138_2267"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_138_2267",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidesVideos);
export default __webpack_public_path__ + "static/media/guides-videos.ea0754cfe21343b85587e33cbc2a08c1.svg";
export { ForwardRef as ReactComponent };